import React from "react";
import "../../Assets/Styles/AboutUs/GetInTouch.css";
import { useNavigate } from "react-router-dom";
import { getAboutUsLastTitleByPartner } from "../../api/axios";
import useSWR from "swr";
import Link from "@mui/material/Link";
import { useTheme } from "@mui/material/styles";
import {getDataByPageAndPosition} from "../../Frontend/Components/Common/common"


function GetInTouch({ button }) {
  const theme = useTheme();

  let navigate = useNavigate();
  const aboutUsBottomButton = getDataByPageAndPosition(button || [], "About Us", "Bottom section") || [];


  const { data: title } = useSWR(
    `aboutUsLastTitle`,
    async () => {
      try {
        const { data } = await getAboutUsLastTitleByPartner();
        return data?.data?.[0]?.tittle || "";
      } catch (error) {
        console.error("error: ", error);
        alert(error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );

  return (
    <div className="GetInTouchWrapper">
      <div
        className="GetTopic mb-2"
      >
        {title}
      </div>
      {aboutUsBottomButton?.length > 0 && <Link
      underline="none"
        sx={{background : `${theme.palette.primary.main} !important`,border: `2px solid ${theme.palette.primary.main} !important`}}
        onClick={() => {
          navigate(aboutUsBottomButton[0]?.buttonLink);
        }}
      >
        {aboutUsBottomButton[0]?.button_name}
      </Link>}
    </div>
  );
}

export default GetInTouch;
